import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {
  DocumentReaderDetailType,
  defineComponents,
  DocumentReaderService
} from "@regulaforensics/vp-frontend-document-components";
import {DocScanWebComponentResult, DocScanWebComponentTextResult} from "../../models/document-scanning.models";

@Component({
  selector: 'document-scanning',
  template: `
    <document-reader
      [attr.license]="license"
      multipage-processing="true"
      start-screen="true"
      multiple="true"
      copyright="false"
      change-camera="true"
      close-button="false"
      (document-reader)="handleDocumentReaderEvents($event)"
    >
    </document-reader>
  `,
  styles: [],
})
export class DocumentScanningComponent implements OnInit {

  @Input() license: string;
  @Output() docScanWebComponentSuccess = new EventEmitter<DocScanWebComponentResult>();

  webComponentResult: DocScanWebComponentResult = {text: [], images: []};

  ngOnInit(): void {

    // init regula sdk
    window["RegulaDocumentSDK"] = new DocumentReaderService();

    defineComponents().then(async () => {
      await window["RegulaDocumentSDK"].prepare();
    });
  }

  async handleDocumentReaderEvents(data: CustomEvent<DocumentReaderDetailType>) {

    if (data.detail.action === 'PROCESS_FINISHED') {
      console.log('PROCESS_FINISHED', data.detail.data.status);

      const success = data.detail.data?.status === 1;

      if (success) {
        this.buildWebComponentResult(data);
      } else {
        console.log('error', data.detail.data)
      }

    }
  }


  private buildWebComponentResult(data: CustomEvent<DocumentReaderDetailType>) {
    const response = data.detail.data.response;

    // Handle text response
    if (response.text) {
      response.text.fieldList.forEach((textField) => {
        const text: DocScanWebComponentTextResult = {
          fieldName: textField.fieldName,
          fieldType: textField.fieldType,
          value: textField.value,
          status: Number(textField.status)
        };

        this.webComponentResult.text.push(text);
      });
    } else {
      console.log('no text response');
    }

    // Handle images response
    if (response.images) {
      const images = [];
      response.images.fieldList.forEach(field => {
        // todo: Need to recheck this, as we might need images that are not cropped for some reason in the future

        // Getting only uncropped images for better results on BE processing
        const uncroppedImages = field.valueList.filter(docImg => docImg.containerType === 16);
        images.push(...uncroppedImages);
      });

      images.forEach(image => {
        this.webComponentResult.images.push({base64: image.value, type: image.type})
      });

    } else {
      console.log('no images response')
    }

    this.docScanWebComponentSuccess.emit(this.webComponentResult);
  }
}
